import Swiper from 'swiper/bundle';

export function initBlogList(swiperClass) {
    new Swiper(`.${swiperClass}`, {
        // мобильная версия по умолчанию
        slidesPerView: 1,
        spaceBetween: 0,
        watchSlidesProgress: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            // при ширине экрана >=768px — 3 слайда
            768: {
                slidesPerView: 3,
                spaceBetween: 0, // можно свой отступ
            },
        },
    });
}

export function initProductSwiper(swiperClass, swiperPrevClass) {
    console.log('initProductSwiper swiperINIT');

    const swiperPrev = new Swiper("." + swiperPrevClass, {
        spaceBetween: 10,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesProgress: true,

        breakpoints: {
            // при ширине экрана >=768px — 3 слайда
            768: {
                slidesPerView: 4,
            },
        },
    });

    const swiper = new Swiper("." + swiperClass, {
        slidesPerView: 1,
        spaceBetween: 15,
        watchSlidesProgress: true,
        effect: "fade",
        autoHeight: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,

        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: swiperPrev,
        },
    });
}

export function initIngredientsSwiper(swiperClass) {
    console.log('initIngredientsSwiper swiperINIT', swiperClass);
    new Swiper(`.${swiperClass}`, {
        // мобильная версия по умолчанию
        slidesPerView: 1,
        spaceBetween: 12,
        watchSlidesProgress: true,
        freeMode: true,
        breakpoints: {
            // при ширине экрана >=768px — 3 слайда
            768: {
                slidesPerView: 4,
                spaceBetween: 24, // можно свой отступ
            },
        },
    });
}
